export default {
  fullName: function (mitarbeiter) {
    if (!mitarbeiter) return ""
    return `${mitarbeiter.vorname} ${mitarbeiter.nachname || mitarbeiter.name}`
  }
}